import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";

import applicationReducer from "./application";

const store = configureStore({
  reducer: {
    application: applicationReducer,
  },
  middleware: [
    ...getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
  ],
});

export { store };
